import { FC } from 'react';
import { cn } from '../../../utils/cn';
export type LoadingIndicatorProps = {
  className?: string;
  indicatorClassName?: string;
  size?: 'default' | 'icon';
  textClassName?: string;
};
export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  className,
  indicatorClassName,
  size = 'default',
  textClassName
}) => {
  const indicatorClasses = cn('animate-spin size-4 border-pl-blue-600 border-3 border-t-transparent rounded-full dark:border-pl-blue-500', indicatorClassName);
  const containerClasses = cn('inline-grid grid-flow-col gap-2 items-center', className);
  if (size === 'icon') {
    const loadingClasses = cn(containerClasses, indicatorClasses);
    return <span className={loadingClasses} role="status" aria-label="loading">
        <span className="sr-only">Loading</span>
      </span>;
  } else {
    const textClasses = cn('font-medium text-base', textClassName);
    return <span className={containerClasses}>
        <span className={indicatorClasses} role="status" aria-label="loading"></span>
        <span className={textClasses}>Loading</span>
      </span>;
  }
};